export default "__VITE_ASSET__frjF67tA__"